export const hslToString = (
  color:
    | (Pick<Queries.SanityHslaColor, "h" | "s" | "l"> & {
        a?: Queries.SanityHslaColor["a"] | null;
      })
    | null,
  alpha?: boolean | number,
  full?: boolean,
): string | null => {
  if (
    color === null ||
    color.h === null ||
    color.s === null ||
    color.l === null
  ) {
    return null;
  }

  const components = [
    color.h.toString(),
    `${(color.s * 100).toFixed(5)}%`,
    `${(color.l * 100).toFixed(5)}%`,
  ];

  if (typeof alpha === "number") {
    components.push(alpha.toFixed(5));
  } else if (alpha && color.a !== undefined && color.a !== null) {
    components.push(color.a.toFixed(5));
  }

  if (full === true) {
    return `${components.length > 3 ? 'hsla' : 'hsl'}(${components.join(',')})`;
  }

  return components.join(",");
};
